import { useQuery } from '@tanstack/react-query'
import { userW2Status } from './keys'
import { getUserW2Status } from 'api/user/w2Status'

export const useUserW2Status = (userId: string | undefined) => {
  return useQuery({
    queryKey: userW2Status(userId),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => getUserW2Status({ userId: userId! }),
    enabled: !!userId,
  })
}
